export const SEND_KDF_ITERATIONS = 100000;
